'use strict';
// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require('../internals/add-to-unscopables');

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.array.unscopables.flat.js
// module id = 735
// module chunks = 0